import React, { useState } from 'react';

const TestContext = React.createContext();

const TestProvider = ({ children }) => {
  const [pagesTestmode, setPagesTestmode] = useState(false);
  const [paymentsSubscriptionsTestmode, setPaymentsSubscriptionsTestmode] =
    useState(false);
  const [paymentsChargesTestmode, setPaymentsChargesTestmode] = useState(false);
  const [couponsTestmode, setCouponsTestmode] = useState(false);
  const [customersTestmode, setCustomersTestmode] = useState(false);

  return (
    <TestContext.Provider
      value={{
        pagesTestmode,
        setPagesTestmode,
        paymentsSubscriptionsTestmode,
        setPaymentsSubscriptionsTestmode,
        paymentsChargesTestmode,
        setPaymentsChargesTestmode,
        couponsTestmode,
        setCouponsTestmode,
        customersTestmode,
        setCustomersTestmode,
      }}
    >
      {children}
    </TestContext.Provider>
  );
};

function useTestContext() {
  const context = React.useContext(TestContext);

  if (context === undefined) {
    throw new Error('useTestContext must be used within a TestProvider');
  }

  return context;
}

export { TestProvider, useTestContext };
